import React from 'react';
import { Link } from 'react-router-dom';
import './BHeader.css'; // <-- El import ya estaba

function BHeader({ onScrollTo, onToggleTheme, themeIcon }) {
  
  const handleScroll = (sectionId) => {
    if (onScrollTo) {
      onScrollTo(sectionId);
    }
  };

  return (
    // 🩹 CIRUGÍA: Usamos la clase base 'b-header'
    <header className="b-header">
      <div className="container">
        {/* 🩹 CIRUGÍA: Usamos 'b-header-content' para la estructura flex */}
        <div className="b-header-content">
          
          {/* 1. SECCIÓN IZQUIERDA (LOGO) */}
          <div className="b-header-left">
            <Link to="/business" className="logo-link">
              <img 
                // Asumimos que quieres usar los mismos logos que en el resto del sitio
                // Usamos themeIcon para determinar el tema actual
                src={themeIcon === '☀️' ? '/logo-dark.png' : '/logo-light.png'} 
                alt="Non Stop Learning Logo" 
                className="b-header-logo-img"
              />
            </Link>
            {/* Mantenemos el subtítulo de "Empresas" aquí */}
            <div className="logo-subtitle">SOLUCIONES EMPRESARIALES</div>
          </div>
          
          {/* 2. SECCIÓN DERECHA (BOTONES) - Eliminamos la sección <nav> central */}
          <div className="b-header-right">
            {/* 🩹 CIRUGÍA: Movimos "Para Estudiantes" aquí */}
            <Link to="/landing" className="b-header-btn-secondary">Para Estudiantes</Link> 
            <Link to="/login" className="b-header-btn-secondary">Log In</Link>
            <button className="b-header-btn-primary" onClick={() => handleScroll('contact')}>Agendar Demo</button>
            <button 
              className="b-header-theme-toggle" 
              onClick={onToggleTheme} 
            >
              {themeIcon}
            </button>
          </div>

        </div>
      </div>
    </header>
  );
}

export default BHeader;

